import { Accordion as AccordionPrimitive } from "radix-ui";
import React from "react";

import { cn } from "~/components/ui/cn";
import { MinusIcon } from "~/components/ui/icons/minus";
import { PlusIcon } from "~/components/ui/plus";

const FaqAccordion = AccordionPrimitive.Root;

const FaqAccordionItem: React.FC<
  React.ComponentProps<typeof AccordionPrimitive.Item>
> = ({ className, ...props }) => (
  <AccordionPrimitive.Item
    className={cn("border-t border-gray-300", className)}
    {...props}
  />
);
FaqAccordionItem.displayName = "FaqAccordionItem";

const FaqAccordionTrigger: React.FC<
  React.ComponentProps<typeof AccordionPrimitive.Trigger>
> = ({ className, children, ...props }) => (
  <AccordionPrimitive.Header className="flex">
    <AccordionPrimitive.Trigger
      className={cn(
        "group flex flex-1 items-center justify-between py-6 font-bold text-green-900 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-900/30 data-[state=open]:pb-2",
        className,
      )}
      {...props}
    >
      {children}
      <PlusIcon className="hidden size-6 text-gray-500 group-data-[state=closed]:block" />
      <MinusIcon className="hidden size-6 text-gray-500 group-data-[state=open]:block" />
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
);
FaqAccordionTrigger.displayName = "FaqAccordionTrigger";

const FaqAccordionContent: React.FC<
  React.ComponentProps<typeof AccordionPrimitive.Content>
> = ({ className, children, ...props }) => (
  <AccordionPrimitive.Content
    className="data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden text-sm transition-all"
    {...props}
  >
    <div className={cn(className)}>{children}</div>
  </AccordionPrimitive.Content>
);

FaqAccordionContent.displayName = "FaqAccordionContent";

export {
  FaqAccordion,
  FaqAccordionContent,
  FaqAccordionItem,
  FaqAccordionTrigger,
};
